class AppError extends Error {
  constructor(
    statusCode,
    message,
    name = undefined,
    isOperational = true,
    error = {},
  ) {
    super(message);
    this.statusCode = statusCode;
    this.isOperational = isOperational;
    this.name = name;
    this.error = error;
    Error.captureStackTrace(this, this.constructor);
  }
}

export default AppError;
